import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
    selector: 'sp-variant-size-chart-delete-alert',
    templateUrl: './variant-size-chart-delete-alert.component.html',
    styleUrls: ['./variant-size-chart-delete-alert.component.scss'],
})
export class VariantSizeChartDeleteAlertComponent implements OnInit {
    @Output() closeDeleteEvent = new EventEmitter<void>();
    @Output() undoActionEvent = new EventEmitter<void>();

    constructor() {}

    ngOnInit(): void {}

    undoDeleteImage(): void {
        this.undoActionEvent.emit();
    }

    closeDeleteAlertSnackBar(): void {
        this.closeDeleteEvent.emit();
    }
}
